







import {Component, Vue, Watch} from 'vue-property-decorator'
import {uuid} from 'vue-uuid'
import {namespace} from 'vuex-class';

const auth = namespace('auth')

@Component({
  name: 'c-collected-data-chart'
})
export default class DataFromStendistTime extends Vue {

  @auth.State('exhibitorId') protected _exhibitor: any

  protected getStatistics() {
    this.$store.dispatch('statistics/getStatistics', this._exhibitor)
  }

  protected updateStatistics() {
    this.getStatistics()
    this.$store.state.statistics.isUpdated = true
  }

  protected chartBlocks: any = {}


  updateArgs: boolean[] = [true, true, true]
  id: string = uuid.v1().replace(/\-/g, '')

  chartOptions = {
    chart: {
      style: {"fontSize": "12px"},
      zoomType: 'x',
      height: '350px',
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '50',
      marginBottom: '50',
      colorCount: 50,
      type: 'line',
    },

    title: {
      text: ''
    },

    subtitle: {
      text:
        document.ontouchstart === undefined
          ? this.$t('statistic.collectedDataChart.subtitle')
          : this.$t('statistic.collectedDataChart.subtitleTouched')
    },

    credits: {
      enabled: false
    },

    xAxis: {
      type: 'datetime'
    },

    yAxis: {
      title: {
        text: this.$t('statistic.collectedDataChart.totalScans')
      }
    },

    legend: {
      enabled: false
    },

    plotOptions: {
      line: {
        events: {
          mouseOver: function (e:any) {
            console.log(e.target.index)
          }
        }
      },
      series: {

        lineWidth: 4
      },
      area: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          }
        },
        lineWidth: 1,
        states: {
          hover: {
            lineWidth: 3
          }
        },
        threshold: null
      }
    },
    series: [
      {
        marker: {
          symbol: 'circle',
          radius: 4
        },
        name: 'Александр Александров',
        data: [[1630396800000, 1], [1631782800000, 8], [1635447600000, 3]]
      },
      {
        marker: {
          symbol: 'circle',
          radius: 4
        },
        name: 'Петр Сизов',
        data: [[1631797200000, 0], [1631782800000, 5], [1631887200000, 3]]
      },
      {
        marker: {
          symbol: 'circle',
          radius: 4
        },
        name: 'Петр Васин',
        data: [[1631782800000, 5], [1635447600000, 9]]
      }
      // , {
      //   name: 'Manufacturing',
      //   data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
      // }, {
      //   name: 'Sales & Distribution',
      //   data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387]
      // }, {
      //   name: 'Project Development',
      //   data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227]
      // }, {
      //   name: 'Other',
      //   data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111]
      // }
    ]
  }

  get isUpdated() {
    return this.$store.getters['statistics/getUpdateStatus']
  }

  get shardsForHours() {
    return this.$store.getters['statistics/getShardsForHours'].sort(
      (a: any, b: any) => a.time - b.time
    )
  }

  mounted(): void {
    this.getStatistics()
    this.updateSeries()
  }

  @Watch('shardsForHours')
  isShardsForHoursChanged() {
    this.updateSeries()
  }

  @Watch('isUpdated')
  isUpdatedChanged(oldData: any, newData: any) {
    if (oldData === newData) return

    this.updateSeries()
    this.$store.state.statistics.isUpdated = false
  }

  protected updateSeries(): void {
    let scans: any[] = []

    this.shardsForHours.forEach((elem: any) => {
      scans.push([elem.time * 1000, elem.total])
    })

    const elem: any = this.$refs.charts
    console.log(scans)
    elem.chart.update({
      series: []
    })
  }
}
